<script setup>
// CUSTOM: bocket-activity-messages-toggle — BKT-014
import { ref, computed, onMounted } from 'vue';
import { useConfig } from 'dashboard/composables/useConfig';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import ButtonV4 from 'dashboard/components-next/button/Button.vue';

const BODY_CLASS = 'bocket-show-activity-messages';

const { hideActivityMessagesEnabled } = useConfig();

const showActivityMessages = ref(
  LocalStorage.get(LOCAL_STORAGE_KEYS.SHOW_ACTIVITY_MESSAGES) === true
);

const applyBodyClass = value => {
  document.body.classList.toggle(BODY_CLASS, value);
};

onMounted(() => {
  applyBodyClass(showActivityMessages.value);
});

const toggle = () => {
  showActivityMessages.value = !showActivityMessages.value;
  applyBodyClass(showActivityMessages.value);
  LocalStorage.set(
    LOCAL_STORAGE_KEYS.SHOW_ACTIVITY_MESSAGES,
    showActivityMessages.value
  );
};

const icon = computed(() =>
  showActivityMessages.value ? 'i-lucide-eye-off' : 'i-lucide-eye'
);

const tooltip = computed(() =>
  showActivityMessages.value
    ? 'Ocultar mensajes del sistema'
    : 'Mostrar mensajes del sistema'
);
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <ButtonV4
    v-if="hideActivityMessagesEnabled"
    v-tooltip="tooltip"
    size="sm"
    variant="ghost"
    color="slate"
    :icon="icon"
    class="rounded-md"
    @click="toggle"
  />
</template>

<style lang="scss">
// CUSTOM: bocket-activity-messages-toggle — BKT-014
body:not(.bocket-show-activity-messages)
  .message-bubble-container:has([data-bubble-name='activity']) {
  display: none;
}
</style>
